import { DASHBOARD_TYPE } from '@utils/constants';
import React from 'react';
import {
  NEW_SHARING_DASHBOARD_NAME,
  NOC_SHARING_DASHBOARD_NAME,
  OVB_SHARING_DASHBOARD_NAME,
  ML_SHARING_DASHBOARD_NAME,
  VM_SHARING_DASHBOARD_NAME,
} from '@store/dashboards/tabs/utils/constants';

function getCustomTitle(type) {
  if ([DASHBOARD_TYPE.TIMELINE].includes(type)) {
    return (
      <div>
        <p>Saving of the shared Trends dashboard is not allowed at this time.</p>
        <p>Are you sure you want to close the Dashboard?</p>
      </div>
    );
  }
  return null;
}

function getOkText(type) {
  switch (true) {
    case [DASHBOARD_TYPE.TIMELINE].includes(type):
      return 'Yes';
    case type === DASHBOARD_TYPE.COMPARE:
    case type === DASHBOARD_TYPE.ERROR_DIAGNOSTICS:
    case type === DASHBOARD_TYPE.NOC:
    case type === DASHBOARD_TYPE.OVB:
    case type === DASHBOARD_TYPE.ML:
    case type === DASHBOARD_TYPE.VIEWER_MODULE:
    case type === DASHBOARD_TYPE.TRENDS:
    case type === DASHBOARD_TYPE.AI_ALERT_DIAGNOSTICS:
    case type === DASHBOARD_TYPE.APP_EXPERIENCE:
      return 'Save';
    default:
      return null;
  }
}

function getCancelText(type) {
  switch (true) {
    case [DASHBOARD_TYPE.TIMELINE].includes(type):
      return 'No';
    case type === DASHBOARD_TYPE.COMPARE:
    case type === DASHBOARD_TYPE.ERROR_DIAGNOSTICS:
    case type === DASHBOARD_TYPE.NOC:
    case type === DASHBOARD_TYPE.OVB:
    case type === DASHBOARD_TYPE.ML:
    case type === DASHBOARD_TYPE.VIEWER_MODULE:
    case type === DASHBOARD_TYPE.TRENDS:
    case type === DASHBOARD_TYPE.AI_ALERT_DIAGNOSTICS:
    case type === DASHBOARD_TYPE.APP_EXPERIENCE:
      return "Don't Save";
    default:
      return null;
  }
}

const getDashboardTitle = (tab) => {
  switch (true) {
    case tab.type === DASHBOARD_TYPE.NOC:
      return `${NOC_SHARING_DASHBOARD_NAME}${tab.id}`;
    case tab.type === DASHBOARD_TYPE.OVB:
      return `${OVB_SHARING_DASHBOARD_NAME}${tab.id}`;
    case tab.type === DASHBOARD_TYPE.ML:
      return `${ML_SHARING_DASHBOARD_NAME}${tab.id}`;
    case tab.type === DASHBOARD_TYPE.VIEWER_MODULE:
      return `${VM_SHARING_DASHBOARD_NAME}${tab.id}`;
    default:
      return `${NEW_SHARING_DASHBOARD_NAME}${tab.id}`;
  }
};

export { getOkText, getCancelText, getCustomTitle, getDashboardTitle };
